/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resetDate: NonNullable<unknown> }} Gateway_Spending_Cap_Exceeded_DescriptionInputs */



/**
* | output |
* | --- |
* | "Chat and text-model API calls are refused, oneAI Standard included — on Gateway it is charged like every other model — until you raise the cap or the period ..." |
*
* @param {Gateway_Spending_Cap_Exceeded_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_spending_cap_exceeded_description = /** @type {((inputs: Gateway_Spending_Cap_Exceeded_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Spending_Cap_Exceeded_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Chat und API-Aufrufe für Textmodelle werden abgelehnt, auch für oneAI Standard — bei Gateway wird es wie jedes andere Modell berechnet —, bis du das Limit erhöhst oder die Periode am ${i?.resetDate} endet.`)
	return /** @type {LocalizedString} */ (`Chat and text-model API calls are refused, oneAI Standard included — on Gateway it is charged like every other model — until you raise the cap or the period resets on ${i?.resetDate}.`)
});